import { render, staticRenderFns } from "./GetPackagesAllList.vue?vue&type=template&id=9915400e&"
import script from "./GetPackagesAllList.vue?vue&type=script&lang=js&"
export * from "./GetPackagesAllList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports